import React from 'react';
import {TouchableOpacity, View} from 'react-native';
import {IStateProps} from './model';
import {images} from '../../../../../assets/icons';
import {useStyles} from '../../../../../shared/hooks/styles';
import {Text} from '../../../../../shared/components/text';

export default ({expanded, onPress, title, children, index}: IStateProps) => {
  const styles = useStyles(() => {
    return {
      arrow: {
        marginLeft: 15,
        transform: [{rotate: '-90deg'}],
        color: 'black',
      },
      arrowActive: {
        transform: [{rotate: '90deg'}],
      },
    };
  });

  const {Left: Arrow} = images;

  return (
    <View style={{alignSelf: 'flex-start'}}>
      <TouchableOpacity testID={`accordion-button-${index}-id`} onPress={onPress} style={{marginBottom: 15}}>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            minHeight: 'auto',
          }}>
          <Text type='h6Light'>{title}</Text>
          <View style={[styles.arrow, expanded && styles.arrowActive]}>
            <Arrow width={20} height={20} color={styles.arrow.color} />
          </View>
        </View>
      </TouchableOpacity>
      {expanded ? <View testID={`accordion-body-${index}-id`}>{children}</View> : null}
    </View>
  );
};
